/* eslint-disable prefer-destructuring */

import { EthereumNetwork } from "@mezo/sdk"

// Parsing non-string env variables, since we need array value and env variables
// are fetched as a string
const parseEnvArray = (envVariable: string): string[] => {
  try {
    return JSON.parse(envVariable)
  } catch {
    return []
  }
}

// Environment variables
export const COMMIT_HASH = process.env.COMMIT_HASH

export const SENTRY_DSN = process.env.SENTRY_DSN
export const SENTRY_ENV = process.env.SENTRY_ENV

export const POSTHOG_KEY = process.env.POSTHOG_KEY
export const POSTHOG_HOST = process.env.POSTHOG_HOST

export const SANITY_PROJECT = process.env.SANITY_PROJECT

export const PROJECT_ID = process.env.WALLET_CONNECT_PROJECT_ID
export const GELATO_RELAY_API_KEY = process.env.GELATO_RELAY_API_KEY

export const MEZO_NETWORK = process.env.MEZO_NETWORK

export const ETHEREUM_NETWORK: EthereumNetwork =
  MEZO_NETWORK === "mezo" ? "mainnet" : "sepolia"

export const RPC_URL_ETHEREUM = process.env.RPC_URL_ETHEREUM
export const RPC_URL_MEZO = process.env.RPC_URL_MEZO

export const DISABLED_ASSETS = parseEnvArray(process.env.DISABLED_ASSETS)

export const PORTAL_API_URL = process.env.API_ENDPOINT
export const PORTAL_API_URL_V2 = process.env.API_ENDPOINT_V2
export const PASSPORT_API_URL = process.env.PASSPORT_API_URL
export const TBTC_API_ENDPOINT = process.env.TBTC_API_ENDPOINT

export const GOLDSKY_MEZO_SUBGRAPH_URL = process.env.GOLDSKY_MEZO_SUBGRAPH_URL
